import React from 'react';

const NotFound = () => {
    return (
        <></>
    );
}

export default NotFound;